import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { Switch } from "components"
import classes from "./SsFullscreen.module.scss"

const SsFullscreen = () => {
  const [t] = useTranslation()

  const [fullScreen, setFullscreen] = useState(false)

  const handleFullScreen = () => {
    const docElm = document.documentElement

    const fullScreenMode =
      document.fullScreen ||
      document.mozFullScreen ||
      document.webkitIsFullScreen

    if (fullScreenMode) {
      if (document.exitFullscreen) {
        document.exitFullscreen()

        setFullscreen(false)
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()

        setFullscreen(false)
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()

        setFullscreen(false)
      }
    } else {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()

        setFullscreen(true)
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()

        setFullscreen(true)
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()

        setFullscreen(true)
      }
    }
  }

  return (
    <div className={classes["row"]}>
      <span>{t("حالت_فول_اسکرین")}</span>
      <Switch
        onClick={handleFullScreen}
        checked={fullScreen}
      />
    </div>
  )
}

export default SsFullscreen